import type {
  ProjectGroupRemovalResult,
  ProjectGroupRemovalTarget,
} from "./projectGroupRemovalRunner";

export async function removeProjectGroupMetadata(input: {
  readonly targets: readonly ProjectGroupRemovalTarget[];
  readonly mode: "checkout" | "project" | null;
  readonly removeCheckout: () => Promise<void>;
  readonly removeProject: () => Promise<void>;
}): Promise<readonly ProjectGroupRemovalResult[]> {
  try {
    if (input.mode === "project") await input.removeProject();
    if (input.mode === "checkout") await input.removeCheckout();
    return input.targets.map((target) => ({
      target,
      fileDeletion: "not-requested",
      metadata: "removed",
    }));
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    return input.targets.map((target) => ({
      target,
      fileDeletion: "not-requested",
      metadata: "failed",
      message,
    }));
  }
}
